import { HttpClient } from '../api/client'
import { TokenManager } from '../auth/tokenManager'
import type { ApiResponse } from '@bandos/shared'

// ─── Types ───────────────────────────────────────────────────────────────────

export interface RagInspectorChunk {
  id: string
  document_id: string
  chunk_index: number
  content: string
  token_count: number
}

export interface RagInspectorDocument {
  id: string
  venture_node_id: string
  file_name: string
  file_size: number
  mime_type: string
  chunk_count: number
  summary: string | null
  status: 'processing' | 'ready' | 'error'
  error_message: string | null
  created_at: string
  chunks: RagInspectorChunk[]
}

export interface RagInspectorStats {
  totalDocuments: number
  totalChunks: number
  totalTokens: number
  byVentureNode: Record<string, { docs: number; chunks: number; tokens: number }>
  byStatus: Record<string, number>
}

export interface RagInspectorData {
  documents: RagInspectorDocument[]
  stats: RagInspectorStats
}

// ─── Service ─────────────────────────────────────────────────────────────────

export class RagInspectorService {
  static async getAll(mindmapId: string): Promise<ApiResponse<RagInspectorData>> {
    const headers = await TokenManager.getAuthHeaders()
    return HttpClient.get<RagInspectorData>(`/admin/rag-inspector/${mindmapId}`, headers)
  }
}
